import appIcon from '@/assets/icons/icon.svg';
import appLogo from '@/assets/icons/logo.svg';
import { cn } from '@/shared/lib/cn';

type LogoSize = 'sm' | 'md' | 'lg';

interface NavbarLogoProps {
  size?: LogoSize;
}

const LOGO_SIZES: Record<LogoSize, string> = {
  sm: 'h-6',
  md: 'h-8',
  lg: 'h-10',
};

const ICON_SIZES: Record<LogoSize, string> = {
  sm: 'h-5',
  md: 'h-6',
  lg: 'h-7',
};

export function NavbarLogo({ size = 'lg' }: NavbarLogoProps) {
  return (
    <>
      {/* Logo completo — desktop */}
      <img
        src={appLogo}
        alt="App Logo"
        className={cn('hidden lg:block w-auto', LOGO_SIZES[size])}
      />

      {/* Logo compacto — mobile */}
      <img
        src={appIcon}
        alt="App Logo"
        className={cn('block lg:hidden w-auto', ICON_SIZES[size])}
      />
    </>
  );
}
